import {post, get, del} from '@/utils/request'

// 上传文件
export function uploadFile(data) {
  return post({
    url: `file/file/upload`,
    data,
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

// 删除文件
export function delFile(id) {
  return del({
    url: `file/file/${id}`
  })
}

export function download() {
  return post({
    url: '!Manage/Goods/~java/GoodsManage.edit'
  })
}

// 登出
export function logout(data) {
  return post({
    data,
    url: '!sys/security/~java/Logout'
  })
}

/**
 * 获取当前登录会员信息
 */
export function getCurrentUserInfoAPI(data) {
  return post({
    data,
    url: 'member/login/users'
  })
}